import { Trash2, Send } from "lucide-react";

export default function AdminWaitlist({ ctx }) {
  const { waitlist, delWaitlist, notifyWaitlist } = ctx;

  // Group signups by class
  const groups = {};
  waitlist.forEach((w) => {
    (groups[w.class_id] = groups[w.class_id] || { title: w.class_title, date: w.class_date, class_id: w.class_id, entries: [] }).entries.push(w);
  });
  const groupList = Object.values(groups);

  return (
    <div className="mt-10 space-y-6" data-testid="admin-waitlist">
      <p className="text-sm text-stone-500">People waiting for sold-out classes. When a spot opens (you raise capacity or someone cancels), they're emailed automatically — or hit "Email waiting" to notify them now. Everyone gets a one-click booking link; first to check out gets the seat.</p>
      {groupList.length === 0 ? <p className="text-stone-500">No waitlist signups yet.</p> :
        groupList.map((g) => {
          const waitingCount = g.entries.filter((e) => e.status === "waiting").length;
          return (
            <div key={g.class_id} data-testid={`waitlist-group-${g.class_id}`} className="border-2 border-[#121212] bg-white">
              <div className="flex items-center justify-between gap-3 px-4 py-3 bg-[#F5EFE6] border-b-2 border-[#121212] flex-wrap">
                <div>
                  <p className="font-serif font-black text-lg text-[#121212]">{g.title}</p>
                  <p className="text-xs text-stone-500">{g.date} · {waitingCount} waiting · {g.entries.length} total</p>
                </div>
                <button
                  data-testid={`notify-waitlist-${g.class_id}`}
                  onClick={() => notifyWaitlist(g.class_id)}
                  disabled={waitingCount === 0}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-[#121212] text-[#F2E9D8] hover:bg-black disabled:opacity-40 text-xs tracking-[0.15em] uppercase font-bold"
                >
                  <Send size={14} /> Email waiting ({waitingCount})
                </button>
              </div>
              <div className="divide-y divide-stone-100">
                {g.entries.map((w) => (
                  <div key={w.id} data-testid={`waitlist-${w.id}`} className="px-4 py-3 flex justify-between gap-4 items-center">
                    <div className="min-w-0">
                      <p className="font-medium text-stone-900">{w.name} · {w.email}</p>
                    </div>
                    <div className="flex items-center gap-3 shrink-0">
                      <span className={`text-[10px] tracking-[0.15em] uppercase font-bold px-2 py-1 ${w.status === "notified" ? "bg-[#C6FF33] text-[#121212]" : "bg-stone-100 text-stone-600"}`}>{w.status === "notified" ? "Notified" : "Waiting"}</span>
                      <button data-testid={`del-waitlist-${w.id}`} onClick={() => delWaitlist(w.id)} className="p-2 text-stone-500 hover:text-red-500"><Trash2 size={18} /></button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
    </div>
  );
}
